(() => {

    useDashboardsNavFactory.$inject = ['$state', '$filter', 'hUser', 'brandServices', 'dashboardsPrerequisiteService', 'userPermissions'];

    function useDashboardsNavFactory($state, $filter, hUser, brandServices, dashboardsPrerequisiteService, userPermissions) {
        return function ($scope, isActiveLink, getBrandIds) {

            const sentimentDashboard = {
                title: $filter('translate')('Employee voice'),
                isActive: () => isActiveLink('appLayout.harriSH.dashboards-sentiment-engagement'),
                href: () => $state.href('appLayout.harriSH.dashboards-sentiment-engagement'),
                isVisible: async function () {
                    const brandIds = getBrandIds();

                    const [
                        isOnboardingJourneyEnabled,
                        isHarriEngageServiceEnabled
                    ] = await Promise.all([
                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                        brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, brandIds[0], true)
                    ]);

                    if (isOnboardingJourneyEnabled) {
                        this.title = $filter('translate')('Sentiment Engagement');
                    }

                    return isOnboardingJourneyEnabled || isHarriEngageServiceEnabled;
                },
            };

            let isMainDashboardVisilbe = false;
            const mainDashboard = {
                title: $filter('translate')('Dynamic Landing Page'),
                isActive: () => {
                    return isActiveLink('appLayout.harriSH.dashboards-main-gp') || (isActiveLink('appLayout.harriSH.dashboards-main-parent') && isMainDashboardVisilbe && !isTlOnlyMainDashboardVisilble);
                },
                href: () => {
                    if (hUser.isTopLevelContext()) {
                        return $state.href('appLayout.harriSH.dashboards-main-gp');
                    } else {
                        return $state.href('appLayout.harriSH.dashboards-main-parent');
                    }
                },
                isVisible: async () => {
                    isMainDashboardVisilbe = await dashboardsPrerequisiteService.canViewHaloDashboard(hUser.getActiveBrandIdWithAccess());
                    return isMainDashboardVisilbe;
                },
            };

            let isTlOnlyMainDashboardVisilble;
            const tlOnlyMainDashboard = {
                ...mainDashboard,
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isActive: () => isActiveLink('appLayout.harriSH.dashboards-main-parent') && isTlOnlyMainDashboardVisilble,
                isVisible: async () => {
                    const [
                        policyParser,
                        canViewMainDashboard
                    ] = await Promise.all([
                        userPermissions.getBrandPolicy(hUser.getActiveBrandIdWithAccess()),
                        dashboardsPrerequisiteService.canViewHaloDashboard(hUser.getActiveBrandIdWithAccess())
                    ]);

                    isTlOnlyMainDashboardVisilble =
                        !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                        policyParser.hasAccess(userPermissions.ACCESS_TYPES.TEAM) &&
                        !hUser.isHMAPUser() &&
                        canViewMainDashboard;
                    return isTlOnlyMainDashboardVisilble;
                }
            };

            const dashboardsNavItem = {
                title: $filter('translate')('Enterprise dashboards'),
                icon: {
                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                },
                isActive: () => {
                    return (
                        isActiveLink('appLayout.harriSH.dashboards-main-gp') ||
                        isActiveLink('appLayout.harriSH.dashboards-main-parent') ||
                        isActiveLink('appLayout.harriSH.dashboards-sentiment-engagement') ||
                        isActiveLink('appLayout.harriSH.dashboards-other-engagement') ||
                        isActiveLink('appLayout.harriSH.dashboards-advanced-onboarding-overview') ||
                        isActiveLink('appLayout.harriSH.dashboards-compaas') ||
                        isActiveLink('appLayout.harriSH.dashboards-risk')
                    )
                },
                dropdownOpen: false,
                subItems: [
                    mainDashboard,
                    {
                        ...sentimentDashboard
                    },
                    {
                        title: $filter('translate')('Other Engagement'),
                        isActive: () => isActiveLink('appLayout.harriSH.dashboards-other-engagement'),
                        href: () => $state.href('appLayout.harriSH.dashboards-other-engagement'),
                        isVisible: async () => {
                            const brandIds = getBrandIds();
                            return await brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true);
                        },
                    },
                    {
                        title: $filter('translate')('Advanced Onboarding'),
                        isActive: () => isActiveLink('appLayout.harriSH.dashboards-advanced-onboarding-overview'),
                        href: () => $state.href('appLayout.harriSH.dashboards-advanced-onboarding-overview'),
                        isVisible: async () => {
                            const brandIds = getBrandIds();
                            const [
                                isAutoImportEnabled,
                                isAutoImportProviderMystuff2
                            ] = await Promise.all([
                                brandServices.check(brandServices.SERVICES.APPLICANT_AUTO_IMPORT, brandIds[0], true),
                                brandServices.check(brandServices.SERVICES.APPLICANT_AUTO_IMPORT_MYSTUFF2, brandIds[0], true)
                            ]);

                            return isAutoImportEnabled && isAutoImportProviderMystuff2;
                        },
                    },
                    {
                        title: $filter('translate')('COMPaaS'),
                        isActive: () => isActiveLink('appLayout.harriSH.dashboards-compaas'),
                        href: () => $state.href('appLayout.harriSH.dashboards-compaas'),
                        isVisible: async () => {
                            return await dashboardsPrerequisiteService.canViewCompaasDashboard(hUser.getActiveBrandIdWithAccess());
                        },
                    },
                    {
                        title: $filter('translate')('Risk Analysis'),
                        isActive: () => isActiveLink('appLayout.harriSH.dashboards-risk'),
                        href: () => $state.href('appLayout.harriSH.dashboards-risk'),
                        isVisible: async () => {
                            const brandId = hUser.getActiveBrandIdWithAccess();
                            const riskDetectionService = brandServices.SERVICES.RISK_DETECTION;
                            const isRiskDetectionServiceEnabled = await brandServices.check(
                                riskDetectionService,
                                brandId,
                                true
                            );

                            if (!isRiskDetectionServiceEnabled) return false;

                            let response;
                            try {
                                response = await Promise.all([
                                    dashboardsPrerequisiteService.canViewRiskDashboard(brandId),
                                    ReportingSettingsManagementAPI.getServiceSettings(brandId, riskDetectionService)
                                ]);
                            } catch (e) {
                                console.error(e);
                                return false;
                            }

                            const [canViewRiskDashboard, riskServiceSettings] = response;

                            return (
                                canViewRiskDashboard &&
                                riskServiceSettings.location_filter_type === LOCATION_FILTER_TYPE.ALL_LEVELS
                            );
                        },
                    },
                ]
            };

            const wfmDashboardsNav = [{
                classNames: 'sb-main-items-container',
                title: $filter('translate')('Dashboards'),
                isVisible: async () => {
                    const brandIds = getBrandIds();
                    const [
                        canViewCompaasDashboard,
                        canViewRiskDashboard,
                        canViewHaloDashboard,
                        isOnboardingJourneyEnabled,
                        isHarriEngageServiceEnabled
                    ] = await Promise.all([
                        dashboardsPrerequisiteService.canViewCompaasDashboard(hUser.getActiveBrandIdWithAccess()),
                        dashboardsPrerequisiteService.canViewRiskDashboard(hUser.getActiveBrandIdWithAccess()),
                        tlOnlyMainDashboard.isVisible(),
                        brandServices.check(brandServices.SERVICES.ONBOARDING_JOURNEY, brandIds[0], true),
                        brandServices.check(brandServices.SERVICES.HARRI_ENGAGE, brandIds[0], true)
                    ]);


                    return (
                        canViewCompaasDashboard ||
                        canViewRiskDashboard ||
                        canViewHaloDashboard ||
                        (
                            !hUser.isHMAPUser() &&
                            (
                                isHarriEngageServiceEnabled ||
                                isOnboardingJourneyEnabled
                            )
                        )
                    );
                },
                sections: [
                    {
                        items: [
                            tlOnlyMainDashboard,
                            {
                                title: $filter('translate')('COMPaaS'),
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.schedule.tl-compaas-dashboard'),
                                href: () => $state.href('appLayout.schedule.tl-compaas-dashboard'),
                                isVisible: async () => {
                                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                    return await dashboardsPrerequisiteService.canViewCompaasDashboard(activeBrandId);
                                },
                            },
                            {
                                title: $filter('translate')('Risk Analysis'),
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isActive: () => isActiveLink('appLayout.schedule.tl-dashboards-risk'),
                                href: () => $state.href('appLayout.schedule.tl-dashboards-risk'),
                                isVisible: async () => {
                                    const activeBrandId = hUser.getActiveBrandIdWithAccess();
                                    return await dashboardsPrerequisiteService.canViewRiskDashboard(activeBrandId);
                                },
                            },
                            {
                                ...sentimentDashboard,
                                icon: {
                                    unfilledSvg: '../images/svgs/sh-dashboards.svg',
                                    filledSvg: '../images/svgs/sh-dashboards_filled.svg'
                                },
                                isVisible: async () => {
                                    const policyParser = await userPermissions.getBrandPolicy(hUser.getActiveBrandIdWithAccess());

                                    return (
                                        !hUser.isHMAPUser() &&
                                        !policyParser.hasAccess(userPermissions.ACCESS_TYPES.SOURCE_HIRE) &&
                                        await sentimentDashboard.isVisible()
                                    );
                                }
                            }
                        ]
                    }
                ]
            }];

            return {
                wfmDashboardsNav,
                dashboardsNavItem
            }
        }
    }

    angular
        .module("harriApp")
        .factory('useDashboardsNavFactory', useDashboardsNavFactory);
})();